import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-student-academic-additional-card',
  templateUrl: './student-academic-additional-card.component.html',
  styleUrls: ['./student-academic-additional-card.component.scss']
})
export class StudentAcademicAdditionalCardComponent implements OnChanges, OnDestroy {

  @Input() profileData: any;
  @Input() classRankData: any[];
  @Input() subjectData: any[];
  @Input() currentHighSchoolPlan: any[];

  highSchoolName = '';
  homeSchooled = false;
  onlineHighSchool = false;
  classRankList: any[];
  subjectList: any[];
  rankClassId: any;
  availableYears = [0, 1, 2, 3, 4];
  formsTouched = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['classRankData'] && changes['classRankData'].currentValue) {
      this.classRankList = changes['classRankData'].currentValue;
    }
    if (changes['subjectData'] && changes['subjectData'].currentValue) {
      this.subjectList = changes['subjectData'].currentValue;
    }
    if (changes['profileData'] && changes['profileData'].currentValue) {
      const profileData = changes['profileData'].currentValue;
      this.highSchoolName = profileData.highSchool;
      this.homeSchooled = profileData.homeSchooled;
      this.onlineHighSchool = profileData.onlineHighSchool;
      this.rankClassId = profileData.classRankClassId;
      if (this.classRankList) {
        // TODO: map 'checkedValue' where classRankClassId === value in classRankList
      }
    }
  }

  clearSchoolSelection(clearHighSchool) {
    this.formsTouched = true;
    if (clearHighSchool) {
      this.highSchoolName = '';
    } else if (!clearHighSchool && this.highSchoolName) {
      this.homeSchooled = false;
      this.onlineHighSchool = false;
    }
  }

  getAdditionalData() {
    return {
      highSchoolName: this.highSchoolName,
      homeSchooled: this.homeSchooled,
      onlineHighSchool: this.onlineHighSchool,
      rankClassId: this.rankClassId,
      subjectList: this.subjectList,
      currentHighSchoolplan: this.currentHighSchoolPlan
    }
  }

  getSubjectTitleById(id: string) {
    return this.subjectList.find(c => +c.id === +id).text;
  }

  changeValue(value) {
    this.formsTouched = value;
  }

  ngOnDestroy() {
    this.changeValue('false');
  }
}
